(function (window, document) {
  const colors = [
    "#000",
    "transparent",
    "#ff3d3d",
    "#ff8229",
    "#ffdd00",
    "#1bf013",
    "#13daf0",
    "#6413f0",
    "#f300f7",
    "#f0f0f0",
  ];
  const totalColors = colors.length;

  const logo = [
    [1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 0, 1],
    [1, 0, 1, 0, 1, 1],
    [0, 0, 1, 0, 0, 0],
  ];

  const a1 = 0.0;
  const a2 = 0.05;
  const a3 = 0.1;
  const a4 = 0.2;

  const logoShading = [
    [a1, a1, a1, a1, a1, a1],
    [a2, a1, a1, a2, a2, a1],
    [a2, a2, a2, a2, a2, a2],
    [a3, a3, a2, a4, a2, a2],
    [a4, a3, a3, a4, a3, a3],
    [a4, a4, a3, a4, a4, a4],
    [a4, a4, a4, a4, a4, a4],
    [a4, a4, a4, a4, a4, a4],
    [a4, a4, a4, a4, a4, a4],
  ];

  function createGrid() {
    $("#myheart").empty();
    for (var i = 0; i < logo.length; i++) {
      for (var j = 0; j < logo[i].length; j++) {
        if (logo[i][j] != 0) {
          let color = colors[logo[i][j]];
          if (logo[i][j] === 1) {
            color = "#ffffff";
          } else if (logo[i][j] === colors.length - 1) {
            color = "#555";
          }
          $("#myheart").append(
            `<div class="cubitbg">
            <div class='cubit' id='${i}_${j}' style='background-color: ${color};'>
            <div style='width: 100%; height: 100%; background-color: #000; opacity: ${logoShading[i][j]}'></div>
            </div>
            </div>`
          );
        } else {
          $("#myheart").append("<div class='noncubit'></div>");
        }
      }
    }

    $(".cubit").on("click", function (event) {
      var square = event.currentTarget;
      console.log(square.id);
      console.log(event);
      const coords = square.id.split("_");
      logo[coords[0]][coords[1]]++;
      if (logo[coords[0]][coords[1]] > totalColors - 1) {
        logo[coords[0]][coords[1]] = 1;
      }
      balls.get(square.id)[0] = logo[coords[0]][coords[1]];
      // createGrid();
      $("#unknowrieaf").css("background-color", "red");
      // $(`#${square.id}`).css(
      //   "background-color",
      //   `${logo[coords[0]][coords[1]]}`
      // );
      // $(`#ball_${square.id}`).css(
      //   "background-color",
      //   `${logo[coords[0]][coords[1]]}`
      // );

      const glow = document.getElementById(`ball_${square.id}`);
      glow.style.backgroundColor = colors[logo[coords[0]][coords[1]]];

      glow.classList.toggle("displaynone", logo[coords[0]][coords[1]] < 2);
      setTimeout(function () {
        //do what you need here
        glow.classList.toggle("noalpha", logo[coords[0]][coords[1]] < 2);
      }, 1);

      square.style.backgroundColor = colors[logo[coords[0]][coords[1]]];

      console.log(`Changing color of ${square.id}`);
      //   window.requestAnimationFrame(draw);
    });
  }

  function createDivAnimation() {
    $("#divanimation").empty();
    balls.forEach((value, key, map) => {
      const time = 1 + getRandomInt(3);
      const timeX = 10 + getRandomInt(30);
      const timeY = 10 + getRandomInt(30);
      const delayX = -(timeX * (getRandomInt(100) / 100));
      const delayY = -(timeY * (getRandomInt(100) / 100));
      const bezier = "cubic-bezier(.25,-0.06,.66,.99)";
      // $("#divanimation").append(
      //   `<div id='ball_${key}'style='animation-duration: ${time}s; background-color: ${
      //     colors[value[0]]
      //   };' class='individualball displaynone'></div>`
      // );
      $("#divanimation").append(
        `<div id='ball_${key}'style='animation-duration: ${time}s; background-color: ${
          colors[value[0]]
        }; top:${value[1]}%; left:${
          value[2]
        }%;' class='individualball displaynone noalpha'></div>`
      );
      // $("#divanimation").append(
      //   `<div id='ball_${key}'style='background-color: ${
      //     colors[value[0]]
      //   };' class='individualball displaynone'></div>`
      // );

      const glow = document.getElementById(`ball_${key}`);
      console.log(glow);
      // glow.style.animation = `bounceX ${time}s linear forwards ${getRandomInt(
      //   100
      // )}%, bounceY ${time}s linear forwards ${getRandomInt(100)}%`;
      // glow.style.animation = `bounceX ${timeX}s linear infinite 50%, bounceY ${timeY}s linear infinite`;
      glow.style.animation = `bounceX ${timeX}s ${bezier} infinite ${delayX}s, bounceY ${timeY}s ${bezier} infinite ${delayY}s`;
    });
  }

  const balls = new Map();
  $(document).ready(function () {
    createGrid();

    const div = 1;
    divAnimationElement.width = $(window).width() / div;
    divAnimationElement.height = $(window).height() / div;

    for (var i = 0; i < logo.length; i++) {
      for (var j = 0; j < logo[i].length; j++) {
        if (logo[i][j] != 0) {
          // let x = getRandomInt(divAnimationElement.width);
          // let y = getRandomInt(divAnimationElement.height);
          let x = getRandomInt(100);
          let y = getRandomInt(100);
          let x1 = getRandomInt(1) ? 1 : -1;
          let y1 = getRandomInt(1) ? 1 : -1;
          balls.set(`${i}_${j}`, [logo[i][j], x, y, x1, y1]);
        }
      }
    }

    // var options = {
    //   animate: false,
    //   patternWidth: 80.24,
    //   patternHeight: 100,
    //   grainOpacity: 1.0, //0.05,
    //   grainDensity: 1.99,
    //   grainWidth: 2.59,
    //   grainHeight: 2.69,
    // };
    // grained("#noiseOverlay", options);

    // window.requestAnimationFrame(draw);
    // const canvas = document.getElementById("headercanvas");

    createDivAnimation();

    // const postCardImageLinks = document.querySelectorAll(
    //   ".post-card-image-link"
    // );

    // postCardImageLinks.forEach(function (postCardImageLink) {
    //   const postCardImage = postCardImageLink.querySelector(".post-card-image");
    //   console.log(postCardImage);
    //   postCardImageLink.addEventListener("mousemove", function (e) {
    //     var xPos =
    //       (e.offsetX - postCardImage.offsetWidth / 2) /
    //       postCardImage.offsetWidth;
    //     var yPos =
    //       (e.offsetY - postCardImage.offsetHeight / 2) /
    //       postCardImage.offsetHeight;

    //     const degrees = 8;
    //     const scale = 1.03;
    //     postCardImage.style.transform =
    //       "rotateX(" +
    //       yPos * degrees +
    //       "deg) rotateY(" +
    //       xPos * -degrees +
    //       "deg) scale(" +
    //       scale +
    //       ", " +
    //       scale +
    //       ")";

    //     // postCardImage.style.transform =
    //     //   "rotateY(" + yPos * 80 + "deg) scale(.7, .7)";
    //   });

    //   postCardImageLink.addEventListener("mouseout", function () {
    //     postCardImage.style.transform =
    //       "rotateX(0deg) rotateY(0deg) scale(1, 1)";
    //   });
    // });
  });

  const divAnimationElement = document.getElementById("divanimation");
  // const canvasElement = document.getElementById("headercanvas");
  // const canvas = canvasElement.getContext("2d");

  // let time = Date.now();
  // function draw() {
  //   canvas.clearRect(0, 0, canvasElement.width, canvasElement.height);
  //   let drawn = false;

  //   const now = Date.now();
  //   const ms = now - time;
  //   // console.log(ms + " ms");
  //   time = now;

  //   balls.forEach((value, key, map) => {
  //     if (value[0] > 1) {
  //       drawn = true;
  //       const circle = new Path2D();
  //       circle.arc(value[1], value[2], canvasElement.width / 5, 0, 2 * Math.PI);

  //       // canvas.filter = `blur(${canvasElement.width / 10}px)`;
  //       // canvas.globalAlpha = 0.8;
  //       canvas.fillStyle = colors[value[0]];
  //       canvas.fill(circle);

  //       value[1] += value[3] * 0.2;
  //       value[2] += value[4] * 0.2;

  //       if (value[1] < 0) value[3] = 1;
  //       if (value[1] > canvasElement.width) value[3] = -1;

  //       if (value[2] < 0) value[4] = 1;
  //       if (value[2] > canvasElement.height) value[4] = -1;
  //     }
  //   });

  //   // if (drawn)
  //   // window.requestAnimationFrame(draw);
  // }

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
})(window, document);
